const ReceiptForm = () => {
    return (
        <>
            <div>
                ReceiptForm
            </div>
        </>
    )
}
export { ReceiptForm }